module.exports = __webpack_public_path__ + "img/2.a56450d0.jpg";